import loader from './loader';

export const appConfig = {
  apiBaseUrl: loader.getConfigValue('REACT_APP_API_BASE_URL') as string,
  appInsightsKey: loader.getConfigValue('REACT_APP_APP_INSIGHTS_KEY') as string,
  configCatKey: loader.getConfigValue('REACT_APP_CONFIGCAT_SDK_KEY'),
  configCatPollingInterval: (loader.getConfigValue('REACT_APP_CONFIGCAT_POLLING_INTERVAL') ||
    60) as number,
  loginUrl: loader.getConfigValue('REACT_APP_LOGIN_URL') as string,
  pendoApiKey: loader.getConfigValue('REACT_APP_PENDO_API_KEY'),
};
